module.exports = "<footer>\n  <a routerLink=\"quotazioni-cellulari-usati\">Tutti i marchi</a>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/footer/footer.component.html
// module id = 743
// module chunks = 1